import { useQuery } from "react-query";
import { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "../../config/supabaseClient";
import { fetchUserRowsByUsername } from "../HelperFunction/HelperFunction";
import { getDataByBundle } from "../HelperFunction/UtilHelperFunction";

/**
 * Load User info.
 * Shares an in-flight fetch with `getUserAndCheckExistence` so dashboard
 * profile setup + entitlements do not double-hit `user` on the same username.
 */
export function useLoadUser(
  username: any,
  client: SupabaseClient = supabase
) {
  async function getUser() {
    try {
      const data = await fetchUserRowsByUsername(username, client);
      if (!data || data.length === 0) return false;
      return getDataByBundle(data[0]);
    } catch {
      return false;
    }
  }

  return useQuery(["getUser", username], getUser, {
    enabled: Boolean(username),
    refetchOnWindowFocus: false,
  });
}
